/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import {service as StateService} from "../../../Services/StateService";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";
import React from "react";

export class StateFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.setInitialState({
			states: []
		});
	}

	componentDidMount() {
		StateService.Get()
			.then((x) => {
				this.setState({states: x.result});
			});
	}

	@autobind
	_render() {
		return <FormControl
			as="select"
			placeholder="Select A State"
			value={this.props.Value != null ? this.props.Value : ""}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
		>
			<option value="">Select A State</option>
			{
				this.state.states.map((x) => <option key={x.stateId} value={x.stateId}>{x.name}</option>)
			}
		</FormControl>;
	}
}